import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function AboutPage() {
  return <PublicPage slug="about" />;
}
